// extracted by mini-css-extract-plugin
module.exports = {"title":"loader_title__WypxJ","press":"loader_press__OyMif"};